import React from 'react';
import PropTypes from 'prop-types';

import WithLoading from 'components/WithLoading';
import EmployeeExposureItem from './EmployeeExposureItem';

const propTypes = {
  employees: PropTypes.array.isRequired,
};

const EmployeeExposureList = ({ employees }) => {
  if (!employees.length) {
    return null;
  }

  return (
    <ul className="EmployeeExposureList">
      {employees.map(employee =>
        <EmployeeExposureItem employee={employee} key={employee.id} />,
      )}
    </ul>
  )
};

EmployeeExposureList.propTypes = propTypes;

export default WithLoading(EmployeeExposureList);



// WEBPACK FOOTER //
// ./src/features/reports/employee-exposure/EmployeeExposureList.js